module.exports = __webpack_public_path__ + "img/profile_sp.fa02647d.png";